import '@dynamic-labs/sdk-api';
import '../../../shared/logger.js';
import '../../../config/LSSuffix.js';
import { setToLS } from '../../../shared/utils/functions/storage/setToLS.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/utils';
import { AUTH_TOKEN } from '../../constants/localStorage.js';
import '../../constants/colors.js';
import 'ethers';
import '../../../shared/consts/index.js';

const storeAuthToken = (jwt) => {
    // TODO: update it to not use localStorage
    //        when we decide how to handle JWT https://linear.app/dynamic-labs/issue/DYN-178
    setToLS(AUTH_TOKEN, jwt);
};

export { storeAuthToken };
